import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { useSelector } from "@grandvisionhq/state";
import { getSelectedShippingMethod } from "../../../../../../StepShipping/StepShipping/selectors.js";
import { useCheckoutSettings } from "../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
import { isPickupStore } from "../../../../../../utils/utils/shipping-method.js";
import { TitleWithIcon } from "../../../../../../components/TitleWithIcon/components/TitleWithIcon/TitleWithIcon.js";
const ServiceStoreHeading = ({
  shouldHideIcon = false,
  title,
  subtitle
}) => {
  const { features, serviceStore } = useCheckoutSettings();
  const selectedShippingMethod = useSelector(getSelectedShippingMethod);
  const isPickupStoreSelected = isPickupStore(selectedShippingMethod?.method);
  if (!features?.isServiceStoreEnabled || isPickupStoreSelected) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TitleWithIcon, { icon: "store", shouldHideIcon, label: title }), /* @__PURE__ */ React.createElement(Text, { component: "p", className: "checkout-step__subtitle" }, subtitle, !serviceStore?.isOptional && /* @__PURE__ */ React.createElement("span", { className: "service-store__asterisk" }, "*")));
};
export {
  ServiceStoreHeading,
  ServiceStoreHeading as default
};
//# sourceMappingURL=ServiceStoreHeading.js.map
